module.exports = __webpack_public_path__ + "static/media/Auto.dc2b290c.mp3";